import { countriesData } from "@utils/data/countries";
import type { CountryData } from "@/types/country";

const DEFAULT_COUNTRY_CODE = "AE";

function normalizeCountryCode(
  countryCode: string | null | undefined,
): string | null {
  const normalized = countryCode?.trim().toUpperCase();
  if (!normalized || normalized.length !== 2) return null;
  return normalized;
}

export function resolveCountryMetadata(
  countryCode: string | null | undefined,
): CountryData {
  const normalized = normalizeCountryCode(countryCode);
  if (normalized && countriesData[normalized]) {
    return countriesData[normalized];
  }

  return countriesData[DEFAULT_COUNTRY_CODE] as CountryData;
}

export function resolveCurrencyCode(
  countryCode: string | null | undefined,
): string {
  return resolveCountryMetadata(countryCode).currency;
}
